import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 3,
        rowsSize: [4, 0.5, 1],
        colSpan: {
          "2:0": 2,
        },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/14/principle/gammatone-chart-1.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/14/principle/gammatone-chart-2.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Gammatone filter bank",
                    scrollbars: false,
                    styles: {
                      fontWeight: 700,
                    },
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Signal after being filtered",
                    scrollbars: false,
                    styles: {
                      fontWeight: 700,
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "hint",
                  options: {
                    data:
                      "The DTF is made is to pass through a gammatone filterbank. This filterbank is an approximation of the cochlear filtering that happens to any sound entering our ears. This step ensures that the sound is processed in a similar way as to a sound entering a human ear.",
                    direction: "row",
                  },
                },
                styles: {
                  width: "615px",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
